























import { defineComponent, computed, PropType, toRefs } from '@vue/composition-api';
import { CREATE_STATUS, AdgroupFormData, AssetItem, SubmittingCreateStatus } from '@tt4b/ttam-enums';
import { openPageByRouterName, PAGE_URLS, queryToJson } from '@tt4b/ttam-utils';
import { CREATION_SUBMIT_ICON } from './const';

export default defineComponent({
  name: 'TtamSplitTestCreateSuccessDialog',
  components: {
    // AssetBalanceAlert,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    createResultStatus: {
      type: Number as PropType<CREATE_STATUS>,
      required: true,
    },
    assetData: {
      type: Array as PropType<AssetItem[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { createResultStatus, adgroupData } = toRefs(props);

    /** 是否正在提交中 */
    const isSubmitting = computed(() => SubmittingCreateStatus.includes(createResultStatus.value));

    /** 投放多个国家 */
    const isMultipleCountrySelected = computed(() => Boolean(adgroupData.value?.country?.length));

    function handleBackToList() {
      const { aadvid } = queryToJson();
      openPageByRouterName(PAGE_URLS.perfCreativeList, aadvid);
    }

    const CreateResultGif = computed(() =>
      isSubmitting.value ? CREATION_SUBMIT_ICON.SUBMITTING : CREATION_SUBMIT_ICON.SUCCESS,
    );

    return { isSubmitting, isMultipleCountrySelected, CreateResultGif, handleBackToList };
  },
});
